import { Components, Theme } from '@mui/material';

export default {
  defaultProps: {
    autoHideDuration: 6000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  },
  styleOverrides: {
    root: ({ theme }) => ({
      maxWidth: 600,
      overflow: 'hidden',
      boxShadow: theme.shadows[3],
    })
  }
} as Components<Theme>['MuiSnackbar'];